import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import type { ReportingPermissions } from '@core/reports-types';

@Injectable()
export class ReportsPermissionsHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchPermissions(): Observable<ReportingPermissions> {
    return this.httpApi.get<ReportingPermissions>('/permissions');
  }
}
